import { createContext } from "react";
const SizesContext = createContext();
export default SizesContext;